import { axiosClient } from "Api/axoisClient";
import { getMarketplaceOrigin } from "Helpers/marketplaceRedirect";

// Page /silent-auth : chargée dans une iframe cachée par la marketplace pour savoir si le
// dashboard a une session valide. Répond par postMessage, uniquement vers l'origine de la
// marketplace (REACT_APP_MARKET_PATH). Aucun rendu React.
export const runSilentAuth = async () => {
  const origin = getMarketplaceOrigin();
  if (!origin || window.parent === window) return;

  const reply = (payload) =>
    window.parent.postMessage({ type: "b2b-silent-auth", ...payload }, origin);

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");
  if (!token || !user) return reply({ authenticated: false });

  try {
    await axiosClient.get("/check-auth", { skipAuthRedirect: true });
    reply({ authenticated: true, token, user });
  } catch (e) {
    reply({ authenticated: false });
  }
};
